// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-group .form-check {
  display: flex;
  align-items: center;
  gap: 6px;
}
.checkbox-group .form-check .form-check-input {
  margin-top: 0;
  border: 2px solid #636366;
  height: 20px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checkbox-group .form-check .form-check-input:checked {
  background-color: transparent;
  border-color: var(--plus-color-purple-40);
}
.checkbox-group .form-check .form-check-input:checked::before {
  background-color: var(--plus-color-purple-40);
}
.checkbox-group .form-check .form-check-input::before {
  width: 10px;
  height: 10px;
  content: "";
  background-color: transparent;
  padding: 0;
  margin: 0;
  line-height: 10px;
}
.checkbox-group .form-check .content {
  display: flex;
  align-items: center;
  gap: 6px;
}
.checkbox-group.checkbox-group-inline .form-check {
  display: inline-flex;
  vertical-align: middle;
}
.checkbox-group.checkbox-group-inline .form-check + .form-check {
  margin-left: 12px;
}
.checkbox-group.checkbox-group-block .form-check {
  width: 100%;
  justify-content: space-between;
}
.checkbox-group.checkbox-group-block .form-check .form-check-input {
  order: 2;
  margin: 0;
}
.checkbox-group.checkbox-group-block .form-check .content .form-check-label {
  order: 2;
}
.checkbox-group.checkbox-group-block .form-check .content .hint-tooltip {
  order: 1;
}
.checkbox-group.checkbox-group-block .form-check.with-hints {
  padding-left: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Checkbox/Checkbox.scss"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AAAF;AAEE;EACC,aAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAH;AACG;EACC,6BAAA;EACA,yCAAA;AACJ;AAAI;EACC,6CAAA;AAEL;AACG;EACC,WAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;AACJ;AAEE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AAAH;AAIE;EACC,oBAAA;EACA,sBAAA;AAFH;AAGG;EACC,iBAAA;AADJ;AAME;EACC,WAAA;EACA,8BAAA;AAJH;AAKG;EACC,QAAA;EACA,SAAA;AAHJ;AAMI;EACC,QAAA;AAJL;AAMI;EACC,QAAA;AAJL;AAOG;EACC,eAAA;AALJ","sourcesContent":[".checkbox-group {\n\t.form-check {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 6px;\n\n\t\t.form-check-input {\n\t\t\tmargin-top: 0;\n\t\t\tborder: 2px solid #636366;\n\t\t\theight: 20px;\n\t\t\twidth: 20px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t&:checked {\n\t\t\t\tbackground-color: transparent;\n\t\t\t\tborder-color: var(--plus-color-purple-40);\n\t\t\t\t&::before {\n\t\t\t\t\tbackground-color: var(--plus-color-purple-40);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&::before {\n\t\t\t\twidth: 10px;\n\t\t\t\theight: 10px;\n\t\t\t\tcontent: \"\";\n\t\t\t\tbackground-color: transparent;\n\t\t\t\tpadding: 0;\n\t\t\t\tmargin: 0;\n\t\t\t\tline-height: 10px;\n\t\t\t}\n\t\t}\n\t\t.content {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 6px;\n\t\t}\n\t}\n\t&.checkbox-group-inline {\n\t\t.form-check {\n\t\t\tdisplay: inline-flex;\n\t\t\tvertical-align: middle;\n\t\t\t+ .form-check {\n\t\t\t\tmargin-left: 12px;\n\t\t\t}\n\t\t}\n\t}\n\t&.checkbox-group-block {\n\t\t.form-check {\n\t\t\twidth: 100%;\n\t\t\tjustify-content: space-between;\n\t\t\t.form-check-input {\n\t\t\t\torder: 2;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t\t.content {\n\t\t\t\t.form-check-label {\n\t\t\t\t\torder: 2;\n\t\t\t\t}\n\t\t\t\t.hint-tooltip {\n\t\t\t\t\torder: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.with-hints {\n\t\t\t\tpadding-left: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
